import {Component, Input} from '@angular/core';
import {EventItemDto} from "../../../contracts/event-item.dto";
import {NgForOf, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {LanguageService} from "../../../services/language.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-event-item',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    TranslateModule
  ],
  templateUrl: './event-item.component.html'
})
export class EventItemComponent {
  @Input() item: EventItemDto;
  @Input() scrollTargetId?: string;

  constructor(private router: Router,
              public langService: LanguageService) {
  }

  async readMore(event: Event, it: EventItemDto) {
    event.preventDefault();
    event.stopPropagation();

    const slug = this.langService.currentLang() + '/events/' + it.slug;
    await this.router.navigateByUrl(slug);
  }

  scrollToComponent() {
    if (!this.scrollTargetId) return;
    const el = document.getElementById(this.scrollTargetId);
    el.scrollIntoView({behavior: 'smooth', block: 'start'});
  }
}
